<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" ref="formData" label-width="140px">
        <el-row :span="24">
          <!-- 展示班次所属日期，历史未回填数据以横线占位。 -->
          <el-col :span="12">
            <el-form-item prop="shiftDate" label="当班日期">
              {{ formData.shiftDate || '-' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isRefining">
            <el-form-item label="生产编号" prop="byzdA2">{{ formData.byzdA2 || formData.recordId }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              {{ formData.productionDate }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="配方" prop="productId">
              {{ formData.productName }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="规格型号" prop="specName">
              {{ formData.specName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产线" prop="productionLine">
              {{ formData.productionLine }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原料罐" prop="rawMaterialTank">
              {{ formData.rawMaterialTank }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="开罐时间" prop="tankOpeningTime">
              {{ formData.tankOpeningTime }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="isRefining ? '批号' : '编号'" prop="recordCode">
              {{ formData.recordCode }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="原料品名" prop="rawMaterialName">
              {{ formData.rawMaterialName }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="原料供应商" prop="rawMaterialSupplier">
              {{ formData.rawMaterialSupplier }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="实际使用吨位" prop="actualUseTonnage">
              {{ formData.actualUseTonnage }}
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="储运液位吨位记录" prop="storageTransportLevelTonnageRecord">-->
<!--              {{ formData.storageTransportLevelTonnageRecord }}-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="剩余液位" prop="remainingLevel">-->
<!--              {{ formData.remainingLevel }}-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="开机时间" prop="startupTime">
              {{ formData.startupTime }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="关机时间" prop="shutdownTime">
              {{ formData.shutdownTime }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="isRefining ? '当班人' : '开机人'" prop="startupOperator">
              {{ formData.startupOperator }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成数量" prop="recordQuantity">
              {{ formData.recordQuantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isRefining">
            <el-form-item label="入库罐" prop="inboundTank">{{ formData.inboundTank || '-' }}</el-form-item>
          </el-col>
          <el-col :span="12" v-if="isRefining">
            <el-form-item label="入库名称" prop="inboundWarehouseId">{{ formData.inboundWarehouseName || '-' }}</el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isRefining">
            <el-form-item label="关联客户" prop="userId">
              {{ formData.userName }}
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!isRefining">
            <el-form-item label="附件" prop="fileList">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="记录流水" prop="forList">
              <el-table size="mini" stripe border :data="tableData">
                <el-table-column min-width="230" label="流水编号" prop="id">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="$router.push('/inventoryflow/detail?id=' + row.id)">{{ row.id }}</el-button>
                    <el-button v-if="row.id" type="text" size="mini" @click.stop="handleCopyProNo(row.id)">复制</el-button>
                  </template>
                </el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属仓库"
                                 prop="warehouseName"></el-table-column>
                <!-- <el-table-column min-width="200" :show-overflow-tooltip="true" label="类型" prop="ygType">
                  <template v-slot="{ row }">
                    {{ row.ygType === 'B' ? '入库' : '出库' }}
                  </template>
                </el-table-column> -->
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="出入库类型" prop="recType">
                  <template v-slot="{ row }">
                    {{ cyRecTypeMap.get(row.recType) }}
                  </template>
                </el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="品种规格"
                                 prop="specName"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属客户"
                                 prop="userName"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="数量"
                                 prop="recQuantity"></el-table-column>
                <!-- <el-table-column min-width="200" :show-overflow-tooltip="true" label="操作时间"
                  prop="ctime"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="记录来源" prop="sourceType">
                  <template v-slot="{ row }">
                    {{ recordSourceTypeMap.get(row.sourceType) }}
                  </template>
                </el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="记录时间"
                  prop="ctime">
                </el-table-column> -->
                <!-- <el-table-column width="160" label="操作" fixed="right">
                  <template v-slot="{ row }">
                    <template>
                      <el-button type="text" @click="$router.push('/inventoryflow/detail?id=' + row.id)">详情</el-button>
                    </template>
                  </template>
                </el-table-column> -->
              </el-table>

              <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next"
                             :total="total" @current-change="loadData">
              </el-pagination>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { cyRecType, recordSourceType } from '@/utils/dict'
import { copyText } from '@/utils/utils'

export default {
  name: 'ProductRecordDetail',
  data() {
    return {
      cyRecTypeMap: cyRecType,
      recordSourceTypeMap: recordSourceType,
      formData: {
        productId: '', // 产品id
        productName: '', // 配方
        specName: '', // 规格型号
        productionDate: '', // 生产日期
        shiftDate: '', // 当班日期
        productionLine: '', // 生产线
        rawMaterialTank: '', // 原料罐
        tankOpeningTime: '', // 开罐时间
        recordQuantity: '', // 完成数量
        userId: '', // 关联客户
        userName: '', // 客户名称
        fileList: [], // 附件
        forList: [], // 产品配方列表
        outList: [], // 出库列表
        // 新增详情字段
        recordCode: '',
        rawMaterialName: '',
        rawMaterialSupplier: '',
        actualUseTonnage: '',
        storageTransportLevelTonnageRecord: '',
        remainingLevel: '',
        startupTime: '',
        shutdownTime: '',
        startupOperator: ''
      },
      tableData: [],
      page: 1,
      total: 0
    }
  },
  computed: {
    isRefining() {
      return (this.formData.productType || this.$route.query.productType) === '1'
    },
    recordId() {
      return this.$route.query.recordId
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    async handleCopyProNo(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectScProRecordByRecordId, {
        params: { recordId: this.recordId }
      }).then(res => {
        this.formData = res
        this.loadData()
      })
    },
    loadData() {
      this.$axios.get(this.$apis.prodManage.selectLyWareRecByPage, {
        page: this.page,
        size: 10,
        objId: this.recordId
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {
  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
